import React, { FC, useEffect, useMemo } from 'react'
import text from 'styles/utility/text.module.scss'
import classNames from 'classnames'
import { State } from 'index'
import { useSelector } from 'react-redux'
import { DepositHistoryCard } from 'components/Card'
import { useQueryShopPayouts } from 'hooks/revenue'
import { getShopRef, getStoreName } from 'reducks/store/selectors'
import { Spacer } from 'components/Utility'
import { FlexRow } from 'components/Flex'

type Props = {
  payoutId: string
}

const DepositHistoryDetailPrintTemplate: FC<Props> = (props) => {
  const { payoutId } = props
  const storeName = useSelector((state: State) => getStoreName(state))
  const shopRef = useSelector((state: State) => getShopRef(state))
  // 残高照会
  const payouts = useQueryShopPayouts(shopRef?.id, 100)
  const payout = useMemo(() => payouts.find((payout) => payout.payoutId === payoutId), [payouts, payoutId])

  useEffect(() => {
    if (!payout) return
    window.print()
  }, [payout])

  return (
    <div>
      <Spacer size={24} />
      <FlexRow justifyContent={'start'}>
        <Spacer size={16} />
        <p className={classNames(text.font_xlarge)}>{storeName} 様</p>
      </FlexRow>
      {payout && <DepositHistoryCard isPrinted={true} payout={payout} />}
    </div>
  )
}

export default DepositHistoryDetailPrintTemplate
